import Synth from './Synth';
import Single from './Single';
import Loop from './Loop';

export const hasLatestWebAudioSupport = 'AudioContext' in window;
export const hasAnyWebAudioSupport = hasLatestWebAudioSupport || 'webkitAudioContext' in window;
export const AudioContext = window.AudioContext || window.webkitAudioContext;
export const audioWarning =
  'This browser does not support the latest Web Audio API. Some sounds may be disabled.';

const SoundFx = {
  Synth: new Synth(),
  Single: new Single(),
  Accessible: new Loop('accessible'),
  Extensible: new Loop('extensible'),
};

export default SoundFx;
